/* DubSports Surf Shop — theme scripts */
(function () {
  document.documentElement.classList.remove('no-js');

  // Product variant picker
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-variant-json]');
    var form = section.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;

    var variants = JSON.parse(jsonEl.textContent);
    var select = form.querySelector('[data-variant-select]');
    var addButton = form.querySelector('[data-add-button]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var fieldsets = form.querySelectorAll('fieldset[data-option-index]');

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        return;
      }

      select.value = variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (priceCurrent) priceCurrent.innerHTML = variant.price;
      if (priceCompare) {
        priceCompare.innerHTML = variant.compare || '';
        priceCompare.hidden = !variant.compare;
        priceCurrent.parentElement.classList.toggle('price--sale', !!variant.compare);
      }

      if (variant.media) {
        var media = section.querySelector('[data-media-id="' + variant.media + '"]');
        section.querySelectorAll('.product__media-item.is-active').forEach(function (el) { el.classList.remove('is-active'); });
        if (media) {
          media.classList.add('is-active');
          if (window.innerWidth < 990) media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  });

  // Quantity +/- buttons
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
  });

  // Collection sorting
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Close mobile nav on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-nav][open]').forEach(function (d) { d.removeAttribute('open'); });
  });
})();
